// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__EeOMP","col":"styles_col__3Bvnc","fulfillmentStatus":"styles_fulfillmentStatus__26XA5","emailCol":"styles_emailCol__3gNBi"};